import { ServiceData } from '@/types';

import articles from './COOKING_ARTICLES_SK.json';
import recipes from './COOKING_RECIPES_SK.json';
import videos from './COOKING_VIDEOS_SK.json';

export const COOKING_DATA_SK: ServiceData = {
  articles,
  recipes,
  videos,
};
